import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import {
    mapData,
    converTime,
    getPickupHours,
} from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import moment from 'moment'

const SerialNumberManage = (props) => {
    const settingCustomContext = useContext(SettingCustomContext)
    const usercommoncontext = useContext(UserCommonContext)
    const commonContext = useContext(CommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { USStates, allCountries, allStates, allCounties, getAllCounties } =
        commonContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const { searchTableAction, responseStatus, clearResponse } =
        settingCustomContext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext
    const [parkingSlot, setParkingSlot] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        year: Yup.number().required('Required!'),
        lower_bound: Yup.number().required('Lower bound is required!'),
        upper_bound: Yup.number()
            .required('Upper bound is required!')
            .test(
                'is-greater-than-lower',
                'Upper bound must be greater than lower bound',
                function (value) {
                    const { lower_bound } = this.parent // Access the `lower_bound` value

                    // Check if `upper_bound` is greater than `lower_bound`
                    if (value <= lower_bound) {
                        return this.createError({
                            message:
                                'Upper bound must be greater than lower bound',
                        })
                    }
                    return true // If validation passes, return true
                }
            ),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            lower_bound: '',
            where: 'year',
            year: '',
            upper_bound: '',
            date_added: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            values.table = 'serial_number_bounds'
            if (data.status == 'new') {
                values.date_added = new Date()
            }
            values.uniqueValue = values.year

            searchTableAction(values, false, 'serial_number_bounds_create')
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'serial_number_bounds_create' &&
                responseStatus.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                formik.resetForm()
            }
        }
    }, [responseStatus])

    useEffect(() => {
        if (data.status != 'new') {
            formik.setFieldValue('id', data.id)
            const template =
                props?.record?.find((cat) => cat.id === data.id) || {}

            formik.setValues({
                ...formik.values,
                ...template,
            })
        } else {
            resetFrom()
        }
    }, [data])

    const resetFrom = () => {
        formik.setValues({
            id: 0,
            lower_bound: '',
            year: '',
            upper_bound: '',
            where: 'year',
        })
    }

    const details = {
        formik: formik,
        data: [
            {
                label: 'Year',
                placeholder: 'Enter Year',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'year',
            },
            {
                label: 'Lower Bound',
                placeholder: 'Enter Lower Bound',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'lower_bound',
            },
            {
                label: 'Upper Bound',
                placeholder: 'Enter Upper Bound',
                type: 'number',
                required: true,
                class: 'col-6',
                name: 'upper_bound',
            },
        ],
    }

    const submitFunction = () => {
        formik.handleSubmit()
        //toggleFullScreenPopup(false)
    }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'Add New Factory Code'
                    : data.status === 'edit'
                    ? 'Edit Factory Code'
                    : 'Edit Factory Code'
            }
            open={data.popup}
            handleClose={() => {
                toggleFullScreenPopup(false, 'new', 0)
                formik.resetForm()
            }}
        >
            <div className="dashboard addNewListing mt-4">
                <div className="fspBody">
                    {/* <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        > */}
                    <div className="row">{mapData(details)}</div>

                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <SecondaryButton
                            id="location_cancel"
                            label="Cancel"
                            onClick={() => {
                                toggleFullScreenPopup(false)
                                formik.resetForm()
                            }}
                        />
                        <PrimaryButton
                            id="location_submit"
                            label="Submit"
                            onClick={submitFunction}
                        />
                    </div>
                    {/* </form> */}
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default SerialNumberManage
